<!--@keyup="$emit('update:data1', $event.target.value)"-->
<template>
    <div id="itemInventaire">

        <!--Quantité en magasin-->
        <b-row align-v="center">
            <b-col class="aRight" cols="5" :xl="prixSize.xl">
                <span class="txtSign">{{$t('i_Magasin')}}</span>
            </b-col>
            <b-col cols="6" :xl="prixSize.prix">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" :append="$t('i_Un')" decimal="3" v-model="_QteMag"></s-currencyInput>
                </b-row>
            </b-col>
        </b-row>

        <!--Quantité en entrepot-->
        <b-row align-v="center">
            <b-col class="aRight" cols="5" :xl="prixSize.xl">
                <span class="txtSign">{{$t('i_Entrepot')}}</span>
            </b-col>
            <b-col cols="6" :xl="prixSize.prix">
                <b-row align-v="center">
                    <s-currencyInput class="Prix" :append="$t('i_Un')" decimal="3" v-model="_QteEntrepot"></s-currencyInput>
                </b-row>
            </b-col>
        </b-row>

        <!--Vendu-->
        <b-row align-v="center">
            <b-col class="aRight" cols="5" :xl="prixSize.xl">
                <span class="txtQte">{{$t('i_Vendu')}}</span>
            </b-col>
            <b-col cols="6" :xl="prixSize.prix">
                    <span class="txtQte">{{_QteVendu}}</span>
            </b-col>
        </b-row>

        <!--Mis de cote-->
        <b-row align-v="center">
            <b-col class="aRight" cols="5" :xl="prixSize.xl">
                <span class="txtQte">{{$t('i_MiseDeCote')}}</span>
            </b-col>
            <b-col cols="6" :xl="prixSize.prix">
                    <span class="txtQte">{{_QteMC}}</span>
            </b-col>
        </b-row>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'itemInventaire',
    components: {

},
    props: ['prixSize', 'QteMag', 'QteEntrepot', 'QteVendu', 'QteMC'],
    data() {
        return {
            collaps: false,
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme']),
        _QteMag: {
            get: function() {return this.QteMag},
            set: function(modifiedValue){this.$emit('update:QteMag', modifiedValue)}
        },
        _QteEntrepot: {
            get: function() {return this.QteEntrepot},
            set: function(modifiedValue){this.$emit('update:QteEntrepot', modifiedValue)}
        },
        _QteVendu: {
            get: function() {return this.QteVendu},
            set: function(modifiedValue){this.$emit('update:QteVendu', modifiedValue)}
        },
        _QteMC: {
            get: function() {return this.QteMC},
            set: function(modifiedValue){this.$emit('update:QteMC', modifiedValue)}
        }
    }
}
</script>

<style lang="scss" scoped>

</style>